import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// P0.3 — config global (singleton de `GET /config`) disponível a toda a app.
// Até aqui só o ecrã de administração a lia; o modo de UI precisa dela em
// qualquer ecrã.
//
// O valor por defeito é `null` — "ainda não sei". Quem consome trata `null`
// como a configuração actual (modo default), por isso um componente montado
// fora do provider (ex.: testes unitários) comporta-se exactamente como hoje.
const ConfigContext = createContext(null);

// P0.4 — estado de carregamento da config, separado do valor. Quem decide
// ENCAMINHAMENTO (a guarda de /hoje) precisa de distinguir "flag desligada"
// de "ainda não sei", para não redireccionar antes de saber. Fora do provider
// o valor por defeito é "ready": um componente montado sem ele decide já, com
// a config que tiver (nenhum, logo modo default) — como até aqui.
const ConfigStatusContext = createContext("ready");

export function ConfigProvider({ children }) {
  const { status } = useAuth();
  const enabled = status === "authed";
  const { data, isError } = useQuery({
    queryKey: ["config"],
    queryFn: async () => (await api.get("/config")).data,
    enabled,
    staleTime: 5 * 60_000,
  });
  // Só há espera quando faz sentido esperar: autenticado e ainda sem
  // resposta. Sem sessão não há pedido nenhum a decorrer, e um erro decide
  // como "sem config" — nunca deixa a app presa num spinner.
  const configStatus = !enabled ? "ready" : data !== undefined ? "ready" : isError ? "error" : "loading";
  return (
    <ConfigStatusContext.Provider value={configStatus}>
      <ConfigContext.Provider value={data ?? null}>{children}</ConfigContext.Provider>
    </ConfigStatusContext.Provider>
  );
}

export function useAppConfig() {
  return useContext(ConfigContext);
}

export function useConfigStatus() {
  return useContext(ConfigStatusContext);
}
